const DEBUG = false;

const BASE_URL ="https://southcentraldev.com";

export const API_URL = `${BASE_URL}/api/scd-portal`;
export const BILLING_API_URL = `${BASE_URL}/api/billing`;
export const MAIN_API_URL = `${BASE_URL}/api/admin`;
export const EMAIL_API_URL = `${BASE_URL}/api/email`;

export const SITE = "scd-portal"
export const NAME = "South Central Development"

export const getAccessToken = () => localStorage.getItem("access");
export const getRefreshToken = () => localStorage.getItem("refresh");

export function hasAnyAuthToken() {
  return !!(getAccessToken() || getRefreshToken());
}

export function clearAuthStorage() {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.removeItem("user_id");
  localStorage.removeItem("is_staff");
  localStorage.removeItem("is_superuser");
  localStorage.removeItem("site");
  localStorage.removeItem("acting_site");
  localStorage.removeItem("username");
  localStorage.removeItem("email_verified");
  localStorage.removeItem("portal_role");
  localStorage.removeItem("portal_roles");
  localStorage.removeItem("permissions");
  localStorage.removeItem("is_partner");
  localStorage.removeItem("is_client");
  localStorage.removeItem("is_internal");
}

export async function refreshAccessToken() {
  const refresh = getRefreshToken();
  if (!refresh) return getAccessToken();

  try {
    const response = await fetch(`${MAIN_API_URL}/token/refresh/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh }),
    });

    if (!response.ok) {
      console.warn("Refresh token expired or invalid");
      clearAuthStorage();
      return null;
    }

    const data = await response.json();

    if (data?.access) {
      localStorage.setItem("access", data.access);
    }

    // IMPORTANT: save rotated refresh token if backend returns one
    if (data?.refresh) {
      localStorage.setItem("refresh", data.refresh);
    }

    return data?.access || getAccessToken();
  } catch (err) {
    console.error("Error refreshing token:", err);
    return getAccessToken();
  }
}
export function isLoggedIn() {
  return !!(getAccessToken() || getRefreshToken());
}
export async function authFetch(url, options = {}) {
  let access = localStorage.getItem("access");
  let refresh = localStorage.getItem("refresh");

  const makeRequest = async (token) => {
    return fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  };

  let res = await makeRequest(access);

  // If token expired, try refresh
  if (res.status === 401 && refresh) {
    const refreshRes = await fetch(`${MAIN_API_URL}/token/refresh/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh }),
    });
    

    // If refresh fails, logout
    if (!refreshRes.ok) {
      clearAuthStorage();
      window.location.replace("/login");
      return res;
    }

    const data = await refreshRes.json();
    localStorage.setItem("access", data.access);

    // Retry original request with new token
    res = await makeRequest(data.access);
  }

  return res;
}

async function readJsonOrThrow(res, fallbackMessage) {
  const contentType = res.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    return await res.json();
  }
  const body = await res.text();
  console.error("Expected JSON response from API", {
    url: res.url,
    status: res.status,
    contentType,
    bodyStart: body.slice(0, 160),
  });
  throw new Error(fallbackMessage);
}

export async function fetchMe() {
  const token = localStorage.getItem("access");


  if (!token) {
    throw new Error("No access token found");
  }  

  const res = await fetch(`${MAIN_API_URL}/me/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
 
  if(res.status === 401){
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("user_id");
    localStorage.removeItem("is_staff");
    localStorage.removeItem("is_superuser");
    localStorage.removeItem("site");
    localStorage.removeItem("acting_site");
    localStorage.removeItem("username");
    localStorage.removeItem("email_verified");
    localStorage.removeItem("portal_role");
    localStorage.removeItem("portal_roles");
    localStorage.removeItem("permissions");
    localStorage.removeItem("is_partner");
    localStorage.removeItem("is_client");
    localStorage.removeItem("is_internal");
    window.location.replace("/login");
  }
  

  if (!res.ok) {
    clearAuthStorage();
    throw new Error("Failed to fetch user");
  }

  return await readJsonOrThrow(res, "Unable to reach the authentication service. Please try again.");
}

export async function logout(navigate) {
  const refresh = localStorage.getItem("refresh");

  clearAuthStorage();

  if (navigate) {
    navigate("/login", { replace: true });
  } else {
    window.location.replace("/login");
  }

  try {
    await fetch(`${MAIN_API_URL}/logout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refresh }),
    });
  } catch (err) {
    console.warn("Backend logout failed (ignored):", err);
  }
}


export async function parseJsonResponse(response) {
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    return null;
  }
  try {
    return await response.json();
  } catch (err) {
    console.error('Unable to parse JSON response:', err);
    return null;
  }
}

export function responseErrorMessage(response, data, fallback = 'Request failed.') {
  return data?.error?.message || data?.detail || (typeof data?.error === 'string' ? data.error : '') || fallback + " Server returned " + response.status + ".";
}
